/* VOLT waitlist — VOLTAGE / 02 round 4 (dense + alive + proof) */
(() => {
  gsap.registerPlugin(ScrollTrigger);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isWide = matchMedia('(min-width: 1024px)').matches;
  const isMobile = matchMedia('(max-width: 720px)').matches;

  /* ---- Smooth scroll ---- */
  let lenis = null;
  if (!reduced) {
    lenis = new Lenis({ duration: 1.15, easing: t => Math.min(1, 1.001 - 2 ** (-10 * t)), smoothWheel: true, smoothTouch: false });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }

  /* ---- Scroll progress bar ---- */
  const sp = document.getElementById('scrollProgress');
  if (sp) {
    const docH = () => Math.max(1, document.documentElement.scrollHeight - innerHeight);
    addEventListener('scroll', () => { sp.style.transform = `scaleX(${Math.min(1, scrollY / docH())})`; }, { passive: true });
  }

  /* ---- Sparks canvas ---- */
  const cv = document.getElementById('sparks');
  if (cv && !reduced && !isMobile) {
    const ctx = cv.getContext('2d');
    let w, h, dpr = Math.min(devicePixelRatio || 1, 2), particles;
    const init = () => {
      w = cv.clientWidth = innerWidth;
      h = cv.clientHeight = innerHeight;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      particles = Array.from({ length: 40 }, () => spawn());
    };
    const spawn = () => ({ x: Math.random() * w, y: h + Math.random() * h * 0.5, vy: 0.3 + Math.random() * 1.4, vx: (Math.random() - 0.5) * 0.3, r: Math.random() * 1.4 + 0.3, life: 0, max: 200 + Math.random() * 300, hue: Math.random() < 0.55 ? 22 : 200 });
    const tick = () => {
      ctx.fillStyle = 'rgba(10,10,10,0.18)'; ctx.fillRect(0, 0, w, h);
      for (const p of particles) {
        p.life++; p.x += p.vx; p.y -= p.vy;
        const a = Math.max(0, 1 - p.life / p.max);
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `hsla(${p.hue}, 100%, ${50 + p.r * 8}%, ${a * 0.7})`;
        ctx.shadowBlur = 12; ctx.shadowColor = `hsla(${p.hue}, 100%, 60%, ${a})`;
        ctx.fill(); ctx.shadowBlur = 0;
        if (p.y < -20 || p.life > p.max) Object.assign(p, spawn());
      }
      requestAnimationFrame(tick);
    };
    init(); addEventListener('resize', init); requestAnimationFrame(tick);
  }

  /* ---- Hero reveal ---- */
  if (reduced) {
    gsap.set('.title .word', { y: '0%', opacity: 1, filter: 'blur(0px)' });
  } else {
    gsap.timeline({ delay: 0.2, defaults: { ease: 'power3.out' } })
      .to('.title .word', { y: '0%', opacity: 1, filter: 'blur(0px)', duration: 1.0, stagger: 0.12 })
      .from('.sub', { y: 14, opacity: 0, duration: 0.7 }, '-=0.5')
      .from('.hero-form', { y: 14, opacity: 0, duration: 0.7 }, '-=0.5')
      .from('.stack-strip', { y: 14, opacity: 0, duration: 0.7 }, '-=0.5')
      .from('.hero-visual', { x: 24, opacity: 0, duration: 0.9 }, '-=0.7')
      .from('.eyebrow', { opacity: 0, duration: 0.5 }, '-=0.3');
  }

  /* ---- Nav solid state ---- */
  ScrollTrigger.create({
    trigger: '.hero', start: 'bottom 80%', end: 'bottom top',
    onEnter: () => document.querySelector('.nav').classList.add('solid'),
    onLeaveBack: () => document.querySelector('.nav').classList.remove('solid'),
  });

  /* ---- Haptic feedback (Vibration API — graceful no-op where unsupported) ---- */
  const haptic = (ms = 8) => { try { navigator.vibrate && navigator.vibrate(ms); } catch (_) {} };

  /* ---- Live counter ---- */
  let count = 1247;
  const navCounter = document.getElementById('navCounter');
  const ctaCounter = document.getElementById('ctaCounter');
  const mctaCount = document.getElementById('mctaCount');
  const updateCounter = () => {
    const fmt = count.toLocaleString('en-US');
    if (navCounter) navCounter.textContent = fmt;
    if (ctaCounter) ctaCounter.textContent = fmt;
    if (mctaCount) mctaCount.textContent = fmt;
  };
  updateCounter();
  if (!reduced) {
    const tick = () => {
      count += 1;
      [navCounter, ctaCounter].forEach(el => {
        if (!el) return;
        el.animate(
          [{ transform: 'translateY(-4px)', opacity: 0.4 }, { transform: 'translateY(0)', opacity: 1 }],
          { duration: 360, easing: 'cubic-bezier(.4,1.5,.5,1)' }
        );
      });
      updateCounter();
      setTimeout(tick, 18000 + Math.random() * 22000);
    };
    setTimeout(tick, 8000 + Math.random() * 10000);
  }

  /* ---- Toast: "X just joined from Y" ---- */
  const names = ['Sarah', 'Marcus', 'Tyler', 'Amaya', 'Jordan', 'Riley', 'Devin', 'Cassidy'];
  const cities = ['Austin', 'NYC', 'LA', 'Chicago', 'Denver', 'Miami', 'Seattle', 'Atlanta'];
  const toast = document.getElementById('toast');
  if (toast && !reduced) {
    let firedCount = 0;
    const maxFires = isMobile ? 1 : 3;   // throttle on mobile so it doesn't compete with sticky CTA
    const fire = () => {
      if (firedCount >= maxFires) return;
      const name = names[Math.floor(Math.random() * names.length)];
      const city = cities[Math.floor(Math.random() * cities.length)];
      toast.querySelector('.toast-text').innerHTML = `<b>${name}</b> just joined from <em>${city}</em>`;
      toast.hidden = false;
      requestAnimationFrame(() => toast.classList.add('show'));
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => { toast.hidden = true; }, 500);
      }, 4200);
      firedCount++;
    };
    const triggerPoints = isMobile ? [1200] : [600, 2200, 5000];
    let lastTrigger = -1;
    addEventListener('scroll', () => {
      const y = scrollY;
      for (let i = 0; i < triggerPoints.length; i++) {
        if (y > triggerPoints[i] && lastTrigger < i) {
          lastTrigger = i;
          setTimeout(fire, 600);
          break;
        }
      }
    }, { passive: true });
  }

  /* ---- Mobile sticky CTA bar — show after hero exits view ---- */
  const mcta = document.getElementById('mcta');
  if (mcta) {
    const hero = document.querySelector('.hero');
    const cta = document.getElementById('join');
    let inView = false;
    const sync = () => {
      if (!hero) return;
      const heroBottom = hero.getBoundingClientRect().bottom;
      const ctaTop = cta ? cta.getBoundingClientRect().top : Infinity;
      // Show after hero scrolls past, hide once the user reaches the main CTA section
      const shouldShow = heroBottom < 80 && ctaTop > innerHeight - 40;
      if (shouldShow !== inView) {
        inView = shouldShow;
        mcta.classList.toggle('show', shouldShow);
        mcta.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }
    };
    addEventListener('scroll', sync, { passive: true });
    sync();
    mcta.querySelector('a').addEventListener('click', () => haptic(10));
  }

  /* ---- 3D tilt on product image ---- */
  const visual = document.getElementById('heroVisual');
  const lineup = document.querySelector('.lineup');
  if (visual && lineup && !reduced && !isMobile) {
    let rx = 0, ry = 0, tx = 0, ty = 0;
    visual.addEventListener('mousemove', (e) => {
      const r = visual.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      tx = -y * 8; ty = x * 12;
    });
    visual.addEventListener('mouseleave', () => { tx = 0; ty = 0; });
    const animate = () => {
      rx += (tx - rx) * 0.1; ry += (ty - ry) * 0.1;
      lineup.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg)`;
      requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }

  /* ---- Magnetic buttons ---- */
  if (!reduced && !isMobile) {
    document.querySelectorAll('.magnetic').forEach(btn => {
      let mx = 0, my = 0, cx = 0, cy = 0;
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        mx = (e.clientX - (r.left + r.width / 2)) * 0.18;
        my = (e.clientY - (r.top + r.height / 2)) * 0.22;
      });
      btn.addEventListener('mouseleave', () => { mx = 0; my = 0; });
      const tick = () => {
        cx += (mx - cx) * 0.18; cy += (my - cy) * 0.18;
        btn.style.transform = `translate(${cx}px, ${cy}px)`;
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }

  /* ---- Flavor selector ---- */
  document.querySelectorAll('.vf').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.vf').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const idx = parseInt(btn.dataset.flavor);
      const colors = [
        'radial-gradient(closest-side at 50% 65%, rgba(0,170,255,0.6) 0%, transparent 60%)',
        'radial-gradient(closest-side at 50% 65%, rgba(255,45,154,0.55) 0%, transparent 60%)',
        'radial-gradient(closest-side at 50% 65%, rgba(74,225,118,0.55) 0%, transparent 60%)',
      ];
      const glow = document.querySelector('.visual-glow');
      if (glow) glow.style.background = colors[idx];
      haptic(6);
    });
  });

  /* ---- Mobile formula carousel — swipe / dots / scroll-snap ---- */
  const fcards = document.getElementById('formulaCards');
  const fdots = document.getElementById('formulaDots');
  if (fcards && fdots) {
    const cards = [...fcards.querySelectorAll('.fc-card')];
    const dots = [...fdots.querySelectorAll('button')];
    const setActive = (idx) => {
      dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    };
    // dots → scroll
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        haptic(6);
      });
    });
    // scroll → dot sync (debounced via rAF)
    let raf = null;
    fcards.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const center = fcards.scrollLeft + fcards.clientWidth / 2;
        let nearest = 0, dmin = Infinity;
        cards.forEach((c, i) => {
          const cx = c.offsetLeft + c.offsetWidth / 2;
          const d = Math.abs(cx - center);
          if (d < dmin) { dmin = d; nearest = i; }
        });
        setActive(nearest);
      });
    }, { passive: true });
  }

  /* ---- Problem cards reveal ---- */
  if (!reduced) {
    gsap.utils.toArray('.p-card').forEach((card, i) => {
      gsap.from(card, { y: 32, opacity: 0, duration: 0.8, ease: 'power3.out', delay: i * 0.07,
        scrollTrigger: { trigger: card, start: 'top 88%' } });
    });
  }

  /* ---- 2:1 ratio reveal ---- */
  if (!reduced) {
    gsap.from('.cmp-bad, .cmp-good, .cmp-vs, .ratio-foot', {
      y: 30, opacity: 0, duration: 0.9, ease: 'power3.out', stagger: 0.1,
      scrollTrigger: { trigger: '.ratio', start: 'top 75%' },
    });
    /* Animated curve draw on the cmp curves — once they're in view */
    document.querySelectorAll('.cmp-curve path').forEach(p => {
      const len = p.getTotalLength ? p.getTotalLength() : 600;
      p.style.strokeDasharray = len;
      p.style.strokeDashoffset = len;
    });
    ScrollTrigger.create({
      trigger: '.compare', start: 'top 80%',
      onEnter: () => {
        document.querySelectorAll('.cmp-curve path').forEach((p, i) => {
          const len = p.getTotalLength ? p.getTotalLength() : 600;
          p.animate(
            [{ strokeDashoffset: len }, { strokeDashoffset: 0 }],
            { duration: 1400, delay: 200 + i * 200, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }
          );
        });
      },
    });
  } else {
    document.querySelectorAll('.cmp-curve path').forEach(p => { p.style.strokeDashoffset = 0; });
  }

  /* ---- Note section reveal ---- */
  if (!reduced) {
    gsap.from('.note-meta, .note-byline, .note-pull, .note-h, .note-p, .note-foot', {
      y: 30, opacity: 0, duration: 0.9, ease: 'power3.out', stagger: 0.08,
      scrollTrigger: { trigger: '.note', start: 'top 75%' },
    });
  }

  /* ---- Formula scrub: stage on right + 4 content stages on left ---- */
  const stage = document.querySelector('.formula-stage');
  const fill = document.querySelector('.meter-fill');
  const secs = document.querySelector('.m-secs');
  const state = document.querySelector('#formulaState');
  const stageContents = document.querySelectorAll('.stage-content');
  const states = ['DIM', 'SPARK', 'IGNITE', 'ARMED'];

  const setActiveStage = (idx) => {
    stageContents.forEach(el => {
      const s = parseInt(el.dataset.stage);
      el.classList.toggle('active', s === idx);
    });
  };

  if (stage && !reduced) {
    const parts = gsap.utils.toArray('.part');
    parts.forEach(p => {
      const tx = parseFloat(getComputedStyle(p).getPropertyValue('--tx'));
      const ty = parseFloat(getComputedStyle(p).getPropertyValue('--ty'));
      gsap.set(p, { xPercent: tx - 50, yPercent: ty - 50, rotate: gsap.utils.random(-180, 180), opacity: 0, scale: 0.4 });
    });
    gsap.set('.ring-base', { width: 0, height: 0 });
    setActiveStage(0);
    if (state) state.textContent = 'DIM';

    /* Scroll-driven scrub — pin .formula-inner to the viewport top and play
       through +=110% (mobile) or +=150% (desktop) scroll. Using ScrollTrigger
       pin:true (transforms) instead of CSS position:sticky because volt-base-styles
       sets overflow-x:hidden on body, which silently kills sticky on descendants. */
    let lastStage = 0;
    let labelsOn = false;
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.formula-inner',
        start: 'top top',
        end: isMobile ? '+=110%' : '+=150%',
        pin: true,
        anticipatePin: 1,
        scrub: isMobile ? 0.6 : 1.2,
        onUpdate: self => {
          const p = self.progress;
          if (fill) fill.style.transform = `scaleX(${p})`;
          if (secs) secs.textContent = `00:0${(p * 8).toFixed(1)}`.slice(0, 6);
          const idx = Math.min(3, Math.floor(p * 4));
          if (idx !== lastStage) {
            if (state) state.textContent = states[idx];
            setActiveStage(idx);
            lastStage = idx;
          }
          const wantLabels = p >= 0.7;
          if (wantLabels !== labelsOn) {
            stage.classList.toggle('show-labels', wantLabels);
            labelsOn = wantLabels;
          }
        },
      },
    });
    tl.to(parts, { opacity: 1, scale: 1, duration: 0.18, stagger: { each: 0.012, from: 'random' } }, 0);
    tl.to(parts.filter(p => !p.classList.contains('halo')), {
      xPercent: -50, yPercent: -50, rotate: 0, duration: 0.5, ease: 'power2.inOut',
    }, 0.2);
    tl.to('.ring-base', { width: '70%', height: '70%', duration: 0.55, ease: 'power2.out' }, 0.25);
    tl.to('.part.halo', { opacity: 1, scale: 1.4, rotate: 360, duration: 0.65, ease: 'power1.inOut' }, 0.2);
    tl.to('.parts', { rotateY: 30, rotateX: -8, duration: 0.18, ease: 'power2.out' }, 0.78);
    tl.to('.part.core', { scale: 1.15, duration: 0.18, yoyo: true, repeat: 1 }, 0.78);
  } else {
    if (stage) {
      gsap.set('.part', { xPercent: -50, yPercent: -50, opacity: 1, scale: 1, rotate: 0 });
      gsap.set('.ring-base', { width: '70%', height: '70%' });
      gsap.set('.part.halo', { scale: 1.4 });
      stage.classList.add('show-labels');
    }
    if (state) state.textContent = 'ARMED';
  }

  /* ---- Timeline ---- */
  if (!reduced && !isMobile) {
    gsap.utils.toArray('.tl-step').forEach((step, i) => {
      gsap.from(step, { y: 20, opacity: 0, duration: 0.6, ease: 'power3.out', delay: i * 0.08,
        scrollTrigger: { trigger: step, start: 'top 90%' } });
    });
    const progress = document.getElementById('tlProgress');
    if (progress) {
      ScrollTrigger.create({
        trigger: '.timeline', start: 'top 70%', end: 'bottom bottom', scrub: 0.6,
        onUpdate: self => { progress.style.width = `${88 * self.progress}%`; },
      });
    }
  }

  /* ---- Use cases reveal ---- */
  if (!reduced) {
    gsap.utils.toArray('.uc').forEach((card, i) => {
      gsap.from(card, { y: 30, opacity: 0, duration: 0.8, ease: 'power3.out', delay: i * 0.06,
        scrollTrigger: { trigger: card, start: 'top 88%' } });
    });
  }

  /* ---- FAQ reveal ---- */
  if (!reduced) {
    gsap.utils.toArray('.faq-item').forEach((item, i) => {
      gsap.from(item, { y: 20, opacity: 0, duration: 0.7, ease: 'power3.out', delay: i * 0.06,
        scrollTrigger: { trigger: item, start: 'top 92%' } });
    });
  }

  /* ---- CTA reveal ---- */
  if (!reduced) {
    gsap.from('.cta-h, .cta-p, .cta-form, .cta-counter', {
      y: 24, opacity: 0, duration: 0.9, ease: 'power3.out', stagger: 0.08,
      scrollTrigger: { trigger: '.cta', start: 'top 75%' },
    });
  }

  /* ---- EMAIL FORMS ---- */
  const KLAVIYO_COMPANY_ID = 'VBLGzC';
  const KLAVIYO_LIST_ID = 'YazTet';
  const isValidEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);

  const submitToKlaviyo = (email) => {
    return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'VOLT Waitlist',
            profile: { data: { type: 'profile', attributes: { email } } },
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } },
        },
      }),
    });
  };

  const handleForm = (form, emailInput) => {
    if (!form) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = emailInput.value.trim();
      const row = form.querySelector('.form-row');
      const button = form.querySelector('button');
      if (!isValidEmail(email)) {
        emailInput.style.outline = '2px solid #ef4444';
        emailInput.focus();
        setTimeout(() => { emailInput.style.outline = ''; }, 1400);
        return;
      }

      // Optimistic UI: lock + show pending immediately
      const originalHTML = button.innerHTML;
      button.disabled = true;
      emailInput.disabled = true;
      button.innerHTML = `<span>Sending…</span>`;

      // Local backup so we never lose a signup if the network drops
      try {
        const list = JSON.parse(localStorage.getItem('volt_waitlist') || '[]');
        list.push({ email, ts: new Date().toISOString(), source: 'voltage-02' });
        localStorage.setItem('volt_waitlist', JSON.stringify(list));
      } catch (_) {}

      submitToKlaviyo(email)
        .then((r) => r.ok || r.status === 202 ? r : Promise.reject(r))
        .then(() => {
          row.classList.add('sent');
          button.innerHTML = `✓ <span>You're on the list — check your inbox</span>`;
          count += 1;
          updateCounter();
          haptic(18);
          if (!reduced) burst(button.getBoundingClientRect());
          // mirror to the other form so they don't double-submit
          document.querySelectorAll('form').forEach((f) => {
            if (f === form) return;
            const r2 = f.querySelector('.form-row');
            const b2 = f.querySelector('button');
            if (r2 && b2 && !r2.classList.contains('sent')) {
              r2.classList.add('sent');
              b2.innerHTML = `✓ <span>You're already on the list</span>`;
            }
          });
        })
        .catch(() => {
          // Failed — restore form so they can retry
          button.disabled = false;
          emailInput.disabled = false;
          button.innerHTML = originalHTML;
          emailInput.style.outline = '2px solid #ef4444';
          setTimeout(() => { emailInput.style.outline = ''; }, 1800);
          alert('Hmm, that didn\'t go through. Try again in a sec?');
        });
    });
  };
  handleForm(document.getElementById('heroForm'), document.getElementById('heroEmail'));
  handleForm(document.getElementById('ctaForm'), document.getElementById('ctaEmail'));

  function burst(rect) {
    const c = document.createElement('canvas');
    c.style.cssText = 'position:fixed;inset:0;z-index:200;pointer-events:none;';
    c.width = innerWidth; c.height = innerHeight;
    document.body.appendChild(c);
    const ctx = c.getContext('2d');
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const N = 70;
    const ps = Array.from({ length: N }, () => ({
      x: cx, y: cy, vx: (Math.random() - 0.5) * 14, vy: -Math.random() * 12 - 4,
      r: Math.random() * 3 + 1.5, hue: [22, 200, 130, 320][Math.floor(Math.random() * 4)],
      life: 0, max: 60 + Math.random() * 40,
    }));
    const step = () => {
      ctx.clearRect(0, 0, c.width, c.height);
      let alive = 0;
      for (const p of ps) {
        p.life++; p.vy += 0.4; p.x += p.vx; p.y += p.vy;
        const a = Math.max(0, 1 - p.life / p.max);
        if (a > 0) {
          alive++;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle = `hsla(${p.hue}, 100%, 60%, ${a})`;
          ctx.shadowBlur = 16; ctx.shadowColor = `hsla(${p.hue}, 100%, 60%, ${a})`;
          ctx.fill(); ctx.shadowBlur = 0;
        }
      }
      if (alive > 0) requestAnimationFrame(step); else c.remove();
    };
    requestAnimationFrame(step);
  }

  addEventListener('load', () => ScrollTrigger.refresh());
})();
